import { CommonModule } from '@angular/common';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CookieModule } from 'ngx-cookie';

import { RedirectionModule } from '®shared/redirection';

import { AnonymousAuthService } from './anonymous-auth.service';
import { AuthErrorService } from './auth-error.service';
import { AuthService } from './auth.service';
import { authenticatedAuthServiceProvider } from './authenticated-auth.service.provider';
import { PersonaAuthService } from './persona-auth.service';
import { PersonaPadlockService } from './persona-padlock.service';
import { PersonaPkceAuthService } from './persona-pkce-auth.service';
import { PersonaPkceLtiAuthService } from './persona-pkce-lti-auth.service';
import { PersonaPkceSharedService } from './persona-pkce-shared.service';
import { UserScopesService } from './user-scopes.service';

@NgModule({
  imports: [
    CommonModule,
    CookieModule,
    HttpClientJsonpModule,
    HttpClientModule,
    RedirectionModule,
    RouterModule,
  ],
})
export class AuthModule {
  /**
   * The AuthServices should be true, shared singletons.
   *
   * @see {@link https://angular-2-training-book.rangle.io/handout/modules/shared-di-tree.html}
   * @return {ModuleWithProviders} Auth service singletons
   */
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        AnonymousAuthService,
        AuthService,
        AuthErrorService,
        PersonaAuthService,
        PersonaPadlockService,
        PersonaPkceSharedService,
        PersonaPkceAuthService,
        PersonaPkceLtiAuthService,
        UserScopesService,
        authenticatedAuthServiceProvider,
      ],
    };
  }
}
